import {observer_mgl} from "mobx-graphlink";
import {Button, CheckBox, Row, Select, Spinner, Text} from "react-vcomponents";
import {RunInAction_Set, TextPlus} from "web-vcore";
import {store} from "../../../../Store/index.js";
import {SpinnerForPercent} from "../../../../Utils/ReactComponents/SpinnerForPercent.js";
import React from "react";
import {GetEntries} from "js-vextensions";
import {VRAction, VRSettingsSubpanel} from "../../../../Store/main/settings/vr.js";
import {ToneMappingMode, ToneMappingMode_options} from "../../../../Store/main/maps/@MapState/MapSettings.js";
import {ShowObjPlacementsDialog} from "../../../Tools/VR/LHQ/ObjPlacementsDialog.js";
import {skyFileOptions} from "../../../../Store/main/tools/vr.js";

export const SettingsUI_VR = observer_mgl(()=>{
	const uiState = store.main.settings.vr;
	return (
		<>
			<Row mt={5}>
				<Select displayType="button bar" options={GetEntries(VRSettingsSubpanel, "ui")} value={uiState.subpanel} onChange={val=>RunInAction_Set(()=>uiState.subpanel = val)}/>
			</Row>
			{uiState.subpanel == VRSettingsSubpanel.general && <GeneralSubpanel/>}
			{uiState.subpanel == VRSettingsSubpanel.lhq && <LHQSubpanel/>}
		</>
	);
});

const GeneralSubpanel = observer_mgl(()=>{
	const uiState = store.main.settings.vr;
	return (
		<>
			<Row mt={5}>
				<TextPlus info={`
					Tone-mapping mode applied to the VR/LHQ scene's renderer.
					ACES filmic is the R3F default (what the scene was tuned for); None disables tone-mapping (with a linear output space).
				`.AsMultiline(0)}>Tone mapping:</TextPlus>
				<Select ml={5} displayType="button bar" options={ToneMappingMode_options}
					value={uiState.toneMapping}
					onChange={val=>RunInAction_Set(()=>uiState.toneMapping = val as ToneMappingMode)}/>
			</Row>

			<Row style={{fontWeight: "bold"}}>As session host</Row>
			<Row mt={5}>
				<CheckBox text="Receive remote effects" value={uiState.receiveRemoteEffects} onChange={val=>RunInAction_Set(()=>uiState.receiveRemoteEffects = val)}/>
			</Row>

			<Row mt={10} style={{fontWeight: "bold"}}>As session client</Row>
			<Row mt={5}>
				<CheckBox text="Send remote effects" value={uiState.sendRemoteEffects} onChange={val=>RunInAction_Set(()=>uiState.sendRemoteEffects = val)}/>
			</Row>
			<Row mt={5}>
				<Text>Dream panel TTS, volume mult.:</Text>
				<SpinnerForPercent ml={5} max={Number.MAX_SAFE_INTEGER} value={uiState.dreamPanel_ttsVolumeMultiplier} onChange={val=>RunInAction_Set(()=>uiState.dreamPanel_ttsVolumeMultiplier = val)}/>
				<Text ml={10}>Speed mult.:</Text>
				<SpinnerForPercent ml={5} max={Number.MAX_SAFE_INTEGER} value={uiState.dreamPanel_ttsSpeedMultiplier} onChange={val=>RunInAction_Set(()=>uiState.dreamPanel_ttsSpeedMultiplier = val)}/>
			</Row>
			<Row mt={5}>
				<Text>Concept link, volume mult.:</Text>
				<SpinnerForPercent ml={5} max={Number.MAX_SAFE_INTEGER} value={uiState.conceptLink_ttsVolumeMultiplier} onChange={val=>RunInAction_Set(()=>uiState.conceptLink_ttsVolumeMultiplier = val)}/>
			</Row>
			<Row mt={5}>
				<TextPlus info={`
					If the stored image is larger than this value (in either dimension), then it will be resized to fit before transfer. [0 = disabled]
					Note: If final image (after resize/reencode) ends up larger (in bytes) than the original, the original will be sent as-is.
				`.AsMultiline(0)}>Frame-image, transfer size:</TextPlus>
				<Spinner ml={5} min={0} step={1} value={uiState.imageFrame_transferSize} onChange={val=>RunInAction_Set(()=>uiState.imageFrame_transferSize = val)}/>
				<TextPlus ml={5} info={`
					What webp quality level to use when encoding the image for transfer. (triggered if downsize needed, OR if target quality is <100%)
					Note: If final image (after resize/reencode) ends up larger (in bytes) than the original, the original will be sent as-is.
				`.AsMultiline(0)}>Quality:</TextPlus>
				<SpinnerForPercent ml={5} value={uiState.imageFrame_transferQuality} onChange={val=>RunInAction_Set(()=>uiState.imageFrame_transferQuality = val)}/>
			</Row>
			<Row mt={5}>
				<Text>Frame-image, timeout for re-send:</Text>
				<Spinner ml={5} min={0} value={uiState.imageFrame_timeoutForResend} onChange={val=>RunInAction_Set(()=>uiState.imageFrame_timeoutForResend = val)}/>
			</Row>
			<Row mt={5}>
				<Text>Frame preload:</Text>
				<Spinner ml={5} step={0.01} value={uiState.imageFrame_preloadCount} onChange={val=>RunInAction_Set(()=>uiState.imageFrame_preloadCount = val)}/>
				<TextPlus info={`How many "frames in the past" a frame must be before it's considered "expired", and gets its image/video data cleared. (to save memory)`} ml={5}>Expire after:</TextPlus>
				<Spinner ml={5} step={0.01} value={uiState.imageFrame_expireAfter} onChange={val=>RunInAction_Set(()=>uiState.imageFrame_expireAfter = val)}/>
			</Row>
			<Row mt={5}>
				<CheckBox text="Swap directional controls" value={uiState.imageFrame_swapDirectionalControls} onChange={val=>RunInAction_Set(()=>uiState.imageFrame_swapDirectionalControls = val)}/>
			</Row>
			<Row mt={5}>
				<CheckBox text="Swap controllers" value={uiState.imageFrame_swapControllers} onChange={val=>RunInAction_Set(()=>uiState.imageFrame_swapControllers = val)}/>
			</Row>
			<Row mt={5}>
				<Text>B-button action:</Text>
				<Select ml={5} options={GetEntries(VRAction)} value={uiState.bButtonAction} onChange={val=>RunInAction_Set(()=>uiState.bButtonAction = val)}/>
			</Row>
			<Row mt={5}>
				<Text>Memory palace snapshot blur size:</Text>
				<SpinnerForPercent ml={5} value={uiState.memoryPalaceSnapshotBlurSize} onChange={val=>RunInAction_Set(()=>uiState.memoryPalaceSnapshotBlurSize = val)}/>
			</Row>
			<Row mt={5}>
				<CheckBox text="Show stats-panel" value={uiState.stats_show} onChange={val=>RunInAction_Set(()=>uiState.stats_show = val)}/>
				<Text ml={10}>Opacity:</Text>
				<SpinnerForPercent ml={5} value={uiState.stats_opacity} onChange={val=>RunInAction_Set(()=>uiState.stats_opacity = val)}/>
			</Row>
			<Row mt={5}>
				<Text>Headset on, above:</Text>
				<Spinner ml={5} step={0.01} value={uiState.headsetOnWhenAbove} onChange={val=>RunInAction_Set(()=>uiState.headsetOnWhenAbove = val)}/>
				<Text>m</Text>
				<Text ml={5}>Off, below:</Text>
				<Spinner ml={5} step={0.01} value={uiState.headsetOffWhenBelow} onChange={val=>RunInAction_Set(()=>uiState.headsetOffWhenBelow = val)}/>
				<Text>m</Text>
			</Row>
		</>
	);
});

const LHQSubpanel = observer_mgl(()=>{
	const uiState = store.main.tools.vr.scene_lhq;
	return (
		<>
			<Row mt={5}>
				<Text>User position:</Text>
				<Spinner ml={5} min={-Infinity} value={uiState.userPosition.x} onChange={val=>RunInAction_Set(()=>uiState.userPosition.x = val)}/>
				<Spinner ml={5} min={-Infinity} value={uiState.userPosition.y} onChange={val=>RunInAction_Set(()=>uiState.userPosition.y = val)}/>
				<Spinner ml={5} min={-Infinity} value={uiState.userPosition.z} onChange={val=>RunInAction_Set(()=>uiState.userPosition.z = val)}/>
			</Row>
			<Row mt={5}>
				<CheckBox text="Show furniture" value={uiState.showFurniture} onChange={val=>RunInAction_Set(()=>uiState.showFurniture = val)}/>
			</Row>
			<Row mt={5}>
				<Text>Sky file:</Text>
				<Select ml={5} options={skyFileOptions} value={uiState.skyFile} onChange={val=>RunInAction_Set(()=>uiState.skyFile = val)}/>
			</Row>
			<Row mt={5}>
				<Text>Sky intensity:</Text>
				<Spinner ml={5} min={0} step={0.05} value={uiState.skyIntensity} onChange={val=>RunInAction_Set(()=>uiState.skyIntensity = val)}/>
			</Row>
			<Row mt={5}>
				<TextPlus info={`
					Multiplier on the baked-lightmap intensity. (100% = no adjustment; >100% brightens the baked lighting; <100% darkens it)
				`.AsMultiline(0)}>Lightmap intensity:</TextPlus>
				<SpinnerForPercent ml={5} max={Infinity} value={uiState.lightmapIntensity} onChange={val=>RunInAction_Set(()=>uiState.lightmapIntensity = val)}/>
			</Row>
			<Row mt={5}>
				<Text style={{fontWeight: "bold"}}>Placements:</Text>
				<Button ml={5} text="Edit" onClick={()=>ShowObjPlacementsDialog()}/>
			</Row>
		</>
	);
});